import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {choose} from 'lit/directives/choose.js';
import {connect} from 'pwa-helpers';
import {msg} from '@lit/localize';
import store from '../../../store';
import {LocationState} from '../../../slices/lightProfileSlice';

@customElement('visual-solar-start')
export class VisualSolarStart extends connect(store)(LitElement) {

	static styles = css`
		:host {
			display: flex;
			width: 100%;
			height: 100%;
			overflow: hidden;
		}
		.container {
			width: 100%;
		}
		video {
			height: 95%;
			object-fit: cover;
			object-position: bottom center;
			margin: 0 auto;
			display: block;
		}
	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.state = state;
		this.lang = state.status.lang;
		this.region = state.status.region;
		this.translations = state.productData.translations;
	}
	render() {
		const s = this.state;
		return html`
			<div class="container">
				<video autoplay muted loop class="video">
					<source src="/line-assets/video/solarStart.mp4" type="video/mp4">
				</video>
			</div>
		`;
	}
}
